<div class="container-fluid h-100 py-2">
  <div
    class="d-flex flex-column justify-content-center align-items-center h-100"
  >
    <mat-spinner></mat-spinner>
    <div class="p-2">{{ message }}</div>
  </div>
</div>
